import { Link } from "react-router";
import type { KitCard } from "../../../api/catalogue";
import { formatPesos } from "../../../lib/money";
import { Badge } from "../../ui";
import { ListingPhoto } from "../ProductCard";
import { SectionHeading } from "./SectionHeading";

/**
 * Kits that cost less than their parts bought one by one (desktop kit Bundles). Both figures
 * come from the server, priced for whoever is looking.
 */
export function KitCards({ kits }: { kits: KitCard[] }) {
  return (
    <section>
      <SectionHeading title="Kits, cheaper than buying the parts one by one" />
      <ul className="m-0 grid list-none gap-4 p-0 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
        {kits.map((kit) => (
          <li key={kit.id}>
            <Link
              to={`/listings/${kit.id}`}
              className="flex h-full gap-5 rounded-lg border border-border-subtle bg-surface-card p-5 text-inherit shadow-sm hover:border-green-300 hover:shadow-md"
            >
              <ListingPhoto photo={kit.photo} alt="" className="size-24 flex-none rounded-sm border border-border-subtle" />
              <span className="flex min-w-0 flex-col">
                <Badge tone="low" className="self-start">
                  Save {formatPesos(kit.parts_price_cents - kit.price_cents)}
                </Badge>
                <span className="mt-3 type-h4 [font-size:var(--text-base)] text-text-strong">{kit.name}</span>
                <span className="mt-0.5 type-small text-text-muted">{kit.contents.map((part) => `${part.name} ×${part.quantity}`).join(", ")}</span>
                <span className="mt-auto flex flex-wrap items-baseline gap-x-3 pt-3">
                  <span className="type-price [font-size:var(--text-lg)] text-text-strong">{formatPesos(kit.price_cents)}</span>
                  <s className="type-small text-text-muted">
                    <span className="sr-only">Parts bought one by one: </span>
                    {formatPesos(kit.parts_price_cents)}
                  </s>
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
